import "vue-material-design-icons/styles.css";
import MapMarker from "vue-material-design-icons/MapMarker.vue";
import Phone from "vue-material-design-icons/Phone.vue";
import Email from "vue-material-design-icons/Email.vue";
import Star from "vue-material-design-icons/Star.vue";
import Eye from "vue-material-design-icons/Eye.vue";
import EyeOff from "vue-material-design-icons/EyeOff.vue";

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.component("location-on-icon", MapMarker);
  nuxtApp.vueApp.component("phone-icon", Phone);
  nuxtApp.vueApp.component("email-icon", Email);
  nuxtApp.vueApp.component("star-icon", Star);
  nuxtApp.vueApp.component("eye-icon", Eye);
  nuxtApp.vueApp.component("eye-off-icon", EyeOff);
});
